export default __webpack_public_path__ + "static/media/tiny_travelers.a986f44c.png";